(function(){
    'use strict';
    angular.module('Services').factory('FormHelpersService', FormHelpersService);
    FormHelpersService.$inject = [];

    function FormHelpersService() {
        return {
            setFormsToSubmitted: (forms) => {
                forms.every(form => form.$setSubmitted());
            },
            getInvalidForms: (forms) => {
                return forms.filter(form => form.$invalid);
            }
        }
    }
})()



// WEBPACK FOOTER //
// ./js/services/Utilities/FormHelpersService.js